











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddTeamMutation_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removedSuggestedActionId",
      "storageKey": null
    }
  ],
  "type": "AddTeamPayload",
  "abstractKey": null
};

(node ).hash = "d47922d5978cd3093773e967ccadf929";

export default node;
